module.exports = "/assets/cdccfb526c220257112735a7ef78823d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/M7.png
// module id = 1604
// module chunks = 0